import React from 'react';
import '../CSS/style/style.css';

const Gallery = () => {
    const url = "/resource/";

    const gallerys = [
        ,{seq: 4, img: 'Gallery4.jpeg'},
        {seq: 5, img: 'Gallery5.jpeg'}, {seq: 6, img: 'Gallery6.jpeg'},
        {seq: 7, img: 'Gallery7.jpeg'},
        {seq: 8, img: 'Gallery8.jpeg'},
        {seq:10, img: 'Gallery10.jpeg'},
        {seq:12, img: 'Gallery12.jpeg'},
        {seq:13, img: 'Gallery13.jpeg'},
        {seq:14, img: 'Gallery14.jpeg'},
        {seq:15, img: 'Gallery15.jpeg'},
        {seq:16, img: 'Gallery16.jpeg'},
        {seq:17, img: 'Gallery17.jpeg'},
        {seq:19, img: 'Gallery19.jpeg'},
        {seq:20, img: 'Gallery20.jpeg'},
        {seq:21, img: 'Gallery21.jpeg'},
        {seq:22, img: 'Gallery22.jpeg'},
        {seq:33, img: 'Gallery33.jpeg'},
    ];

    // 2개씩 묶기
    const chunkedGallery = [];
    for (let i = 0; i < gallerys.length; i += 2) {
        chunkedGallery.push(gallerys.slice(i, i + 2));
    }

    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="main-container">
                <h2>Gallery</h2>

                {chunkedGallery.map((pair, rowIdx) => (
                    <ul key={rowIdx} className="gallery-row">
                        {pair.map(gallery => (
                            <li key={gallery.seq} className="gallery-item">
                                <img
                                    src={`${url}Gallery/${gallery.img}`}
                                    alt={`Gallery ${gallery.seq}`}
                                    className="img-thumbnail gallery-image"
                                />
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
        </div>
    );
};

export default Gallery;
